export default __webpack_public_path__ + "static/VIRSAT Life Saving Rules Aware-87b485c0f270c2f7ebd06a5ce1d7c225.jpg";